import React from "react";
import "./AccessDenied.css";

const AccessDenied = ({ moduleName }) => {
  return (
    <div className="access-denied">
      <h2 className="access-denied-title">Access Denied</h2>
      <p className="access-denied-message">
        You don't have access to the{" "}
        {moduleName ? `"${moduleName}" ` : ""}module. Please contact your
        administrator to request access.
      </p>
    </div>
  );
};

export default AccessDenied;
